import { render, staticRenderFns } from "./ReplacementsComponent.vue?vue&type=template&id=7cee3c96&scoped=true"
import script from "./ReplacementsComponent.vue?vue&type=script&lang=js"
export * from "./ReplacementsComponent.vue?vue&type=script&lang=js"
import style0 from "./ReplacementsComponent.vue?vue&type=style&index=0&id=7cee3c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cee3c96",
  null
  
)

export default component.exports